export default __webpack_public_path__ + "static/media/click-logo.4f05bec3.png";